// This class used for managing errors
function Errors() {
    this.node = null;
    this.id = null;
    this.declaredClass = null;


    this.init = function() {
        $(this.node).css("display", "block");
        if(this.code==404){
            $("#errorMsg").html("<h2>Looks like the MoGoat ate your page...</h2><strong>The requested page was not found.</strong><br /><br /><p>Sorry, but we can’t find the page you’re looking for. Every once in a while the MoGoat gets out and things get crazy around here.</p>");
        }else{
            $("#errorMsg").html("<h2>"+this.message+"</h2>");
        }

    };

    this.initAllReady = function() {};


}